import { DatePipe, formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { OfferAndAppointmentComponent } from '../offer-and-appointment/offer-and-appointment.component';
import { Config } from 'src/app/app-constant';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AddDeptLocComponent } from '../add-dept-loc/add-dept-loc.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, countryList, formatDateToLocalIso, formatText, formatYearRanges, noWhitespaceValidator, strictEmailValidator } from 'src/app/shared/commen-function-file';
import { filter } from 'rxjs';
import { FilterType } from 'angular-google-charts';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-employee-application-form',
  templateUrl: './employee-application-form.component.html',
  styleUrls: ['./employee-application-form.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class EmployeeApplicationFormComponent implements OnInit {

  userName: any | null;
  loggedInUserRole: any | null;
  companyLogo: any | null;
  buttonColorName: any;

  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any;
  employeeForm: any;
  candidateDetails: any;
  newCategory: any;
  selectedYearForCompetency: any;
  pmsYears: any;
  loggedInUserId: any;
  setPrefix: any;
  setLimit: any;
  isManual: any;
  currentDate: any;
  today: Date = new Date();

  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EmployeeApplicationFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    this.currentDate = (new Date()).toISOString();
    this.candidateDetails = data.candidateId;
    console.log(this.candidateDetails);


    this.employeeForm = this.fb.group({
      // General Information
      salutation: ['', Validators.required],
      firstName: ['', [
        Validators.required,                        // Field is required
        Validators.maxLength(255),                  // Maximum length of 255 characters
                         // Minimum length of 2 characters
        Validators.pattern(/^[A-Za-z\s'.]+$/),      // Only letters, spaces, apostrophes, and hyphens allowed
        noWhitespaceValidator                  // Custom validator to disallow only spaces
      ]],


      lastName: [
        '',
        [
          Validators.required,
        
          Validators.maxLength(255),
          Validators.pattern(/^[A-Za-z\s']+$/), // Only letters, space, apostrophe, hyphen
          noWhitespaceValidator
        ]
      ],

      genders: ['', Validators.required],
      country: ['', Validators.required],
      presentAddress: ['', [Validators.required, Validators.maxLength(255)]],
      permanentAddress: ['', [Validators.maxLength(255)]],
      maritalStatus: [''],
      dateOfBirth: ['', Validators.required],
      age: ['', Validators.required],
      personalEmail: ['', [Validators.required, Validators.email, strictEmailValidator]],
      aadhaarCardNo: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      panNo: ['', [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]$')]],
      unaNo: ['', Validators.pattern(/^\d{12}$/)],
      mobileNo: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]],

      previousExperience: ['', [Validators.pattern(/^\d{1,2}(\.\d{1,2})?$/)]],

      emergencyContact: ['', [Validators.required,Validators.pattern('^[0-9]{10}$')]],
      bloodGroup: ['',Validators.required],
      fathersName: ['', [Validators.maxLength(255), Validators.pattern(/^[A-Za-z\s'.-]+$/)]],
      mothersName: ['', [Validators.maxLength(255), Validators.pattern(/^[A-Za-z\s'.-]+$/)]],

      spouseName: ['', [Validators.maxLength(255), Validators.pattern(/^[A-Za-z\s'.-]+$/)]],
      noOfChildren: ['', [Validators.pattern(/^[0-9]+$/), Validators.max(20)]], // Assuming a max of 20

      relativeWorking: [''],

      // Education Related Information
      highestEducation: ['', [Validators.maxLength(255),
      Validators.pattern(/^[A-Za-z0-9\s.'.,_\-]+$/)]],
      highestEducationInstitute: ['', [Validators.maxLength(255),
      Validators.pattern(/^[A-Za-z0-9\s.'.,_\-]+$/)]],
      highestEducationYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      highestEducationMarks: ['', [Validators.pattern(/^(?:\d{1,3}(?:\.\d{1,2})?%?)?$/), // e.g., 95, 95.5, 99.99
      Validators.max(100)]],
      secondEducation: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s .,'_\-]*$/)

        ]
      ],
      secondEducationInstitute: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s .,'_\-]*$/)

        ]
      ],

      secondEducationYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      secondEducationMarks: ['', [
        Validators.pattern(/^(?:\d{1,3}(?:\.\d{1,2})?)?$/),// allows up to 2 decimal places
        Validators.max(100)
      ]],
      thirdEducation: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s .,'_\-]*$/)

        ]
      ],
      thirdEducationInstitute: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s .,'_\-]*$/)

        ]
      ]
      ,
      thirdEducationYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      thirdEducationMarks: ['', [
         Validators.pattern(/^(?:\d{1,3}(?:\.\d{1,2})?)?$/), // Validates up to 3 digits + optional 2 decimal places
        Validators.max(100)
      ]],
      highestProfessional: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s .,'-]*$/)

      ]],
      highestProfessionalInstitute: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s .,'-]*$/)

      ]],

      highestProfessionalYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      highestProfessionalMarks: [
        '',
        [
          Validators.pattern(/^(?:\d{1,3}(?:\.\d{1,2})?)?$/),// Valid decimal up to 2 digits
          Validators.max(100)                         // Max value: 100
        ]
      ],


      // Prior Employment Related Information
      lastOrganisation: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],

      lastOrganisationJoiningDate: [''],
      lastOrganisationLastWorkingDate: [''],
      lastOrganisationDepartment: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],
      lastOrganisationDesignation: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],

      lastToLastOrganisation: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],

      lastToLastOrganisationJoiningDate: [''],
      lastToLastOrganisationLastWorkingDate: [''],
      lastToLastOrganisationDepartment: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],
      lastToLastOrganisationDesignation: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],

      anyOtherOrganisation: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],

      anyOtherOrganisationJoiningDate: [''],
      anyOtherOrganisationLastWorkingDate: [''],
      anyOtherOrganisationDepartment: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],
      anyOtherOrganisationDesignation: [
        '',
        [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)
        ]
      ],


      //---------------------------------HR ------------------------------------------
      companyId: [''],
      candidateId: [''],

      employmentCategory: ['', Validators.required],
      employmentType: ['', Validators.required],
      retirementAge: [
        '',
        [

          Validators.pattern(/^\d+$/),         // Only digits allowed
          // Minimum age
          Validators.max(100)                 // Maximum age
        ]
      ],

      empStatus: ['Active', Validators.required],
      dateOfJoining: ['', Validators.required],
      groupName: ['', Validators.required],
      // companyName: ['', Validators.required],
      companyName: ['', [Validators.required]],
      reportingManagerName: ['', Validators.required],
      reportingManagerCode: ['', Validators.required],
      dottedReportingManagerName: ['',],
      dottedReportingManagerCode: ['',],
      hodName: ['', Validators.required],
      hodCode: ['', Validators.required],
      band: ['', Validators.required],
      grade: ['', Validators.required],
      designation: ['', Validators.required],
      department: ['', Validators.required],
      subDepartment: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'-]*$/)  // Allows letters, numbers, spaces, dots, apostrophes, and hyphens
        ]
      ],

      workLocationState: ['', [Validators.required,Validators.maxLength(255)]],
      workLocationCity: ['', [Validators.required,Validators.maxLength(255)]],
      designationAtDoj: ['', Validators.required],
      noOfPromotions: ['',[ Validators.max(100)]],
      currentPerformanceScore: ['',],
      currentPerformanceRating: ['',],
      lastYearPerformanceScore: ['',],
      lastYearPerformanceRating: ['',],
      yearBeforeLastYearPerformanceScore: ['',],
      yearBeforeLastYearPerformanceRating: ['',],
      mailBody: ['',],
      mailSubject: ['',],
      //------------------------------------------------current --------------------------------------
      currency: [''],
      salaryStatus: ['', Validators.required],
      bankName: ['', Validators.required],
      bankBranchAddress: [
        '',
        [
          Validators.required,
          Validators.maxLength(255),

        ],
      ],

      bankAccount: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{9,18}$/), // account number: 9–18 digits (typical range)
        ],
      ],
      ifscCode: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]+$/), // standard IFSC pattern: 4 letters, 0, 6 alphanumeric
        ],
      ],


      
effectiveDate:['',Validators.required],
      basicSalaryPm: ['', Validators.required],
      daPm: [''],
      hraPm: [''],
      otherAllowancePm: [''],
      ltaPm: [''],
      medicalAllowancePm: [''],
      washingAllowancePm: [''],
      specialAllowancePm: [''],
      fuelAllowancePm: [''],
      entertainmentAllowancePm: [''],
      educationAllowancePm: [''],
      booksAllowancePm: [''],
      statutoryBonusPm: [''],
      anyOtherAllowancePm: [''],
      grossSalaryPm: ['', Validators.required],
      employeePfPm: [''],
      employerPfPm: [''],
      ptPm: [''],
      lwfPm: [''],
      esicPm: [''],
      otherRetiralPm: [''],
      totalRetiralPm: ['', Validators.required],
      totalCTCIncludingRetiralPM: ['', Validators.required],
      totalCTCIncludingRetiralPA: ['', Validators.required],
      processOfVp: ['', Validators.required],
      annualVariablePayBudget: [''],
      annualTotalCtc: ['', Validators.required],
      incrementOn: ['', Validators.required]
    });


  }



  @HostListener('window:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault(); // Prevents the default enter key behavior
  }

  formatedataVariable = formatText;
  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getAllCountryList();
    this.getpmsyearlist();

    this.getAllCustomFieldsList();
    this.checkAccountNo();

  }

  preventFloatInput(event: KeyboardEvent): void {
    const invalidKeys = ['.', 'e', '+', '-'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text');
    if (clipboardData && !/^\d+$/.test(clipboardData)) {
      event.preventDefault();
    }
  }

  handleInput(event: any, fieldType: string) {
    console.log(fieldType);

    const inputElement = event.target as HTMLInputElement;

    if (fieldType === 'mobileNo' || fieldType === 'emergencyContact') {
      // Allow only numbers and restrict length to 10
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 10) {
        event.preventDefault();
      }
    } else if (fieldType === 'pan') {
      // Convert PAN to uppercase
      inputElement.value = inputElement.value.toUpperCase();
      this.employeeForm.controls['panNo'].setValue(inputElement.value);
    } else if (fieldType === 'aadhaarCardNo') {
      // Aadhaar validation
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 12) {
        event.preventDefault();
      }
    }



  }
  restrictCharacters(event: KeyboardEvent, fieldType: string): void {
    const inputChar = event.key;
    const inputElement = event.target as HTMLInputElement;

    const allowedControlKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
    ];

    const isNumber = /^[0-9]$/.test(inputChar);
    const isControlKey = allowedControlKeys.includes(inputChar);

    if (fieldType === 'unaNo') {
      const currentLength = inputElement.value.length;

      // If it's not a digit or allowed control key, block it
      if ((!isNumber && !isControlKey) || (isNumber && currentLength >= 12)) {
        event.preventDefault();
      }
    }
  }



  countryList: any = countryList

  getCountryList: any = [];
  getAllCountryList() {
    var getCountryList = this.countryList.map((country: any) => country.country);
    getCountryList?.forEach((ele: any) => {
      let obj = {
        id: ele,
        name: ele,
      }
      this.getCountryList.push(obj);
    });

    this.getCountryList = this.getCountryList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));

  }

  customFieldObject: any = [];
  customFieldData: any = [];
  getAllCustomFieldsList() {
    this.httpService.callGetService(this.config.getAllCustomFieldsList).subscribe((data: any) => {
      // this.customFieldObject = [];


      this.customFieldObject = data?.objectData?.setResponse?.map((ele: any) => {
        return {
          fieldId: ele?.id,
          fieldName: ele.fieldName,
          fieldValue: ele.fieldValue ?? null,
          id: null
        }

      });
      this.customFieldData = this.customFieldObject;
      console.log(this.customFieldData);

    })
  }
  salutations = ['Mr.', 'Ms.', 'Mrs.', 'Dr.'];
  employmentCategories: string[] = ['Staff', 'Worker', 'Contractual', 'Trainee'];
  selectedCategory: any;
  employmentTypes: string[] = ['Probation', 'Confirmed'];
  selectedEmploymentType: any; // Holds the selected value
  employmentstatus: any[] = ['Active']
  selectedEmploymentstatus: any;
  salaryStatuses: string[] = ['Process', 'Hold', 'FF'];
  selectedSalaryStatus: string = ''; // Holds the selected value
  vpProcesses: { id: string; name: string }[] = [
    { id: 'VP_ADJUSTED_TO_PERFORMANCE', name: 'Fixed VP' },
    { id: 'NO_VP', name: 'No VP' },
    { id: 'PERCENT_OF_CTC_BASED_ON_RATING', name: '%ge on CTC' }
  ];

  incrementOnOptions: string[] = [
    'Fixed_Annual_CTC',
    'Total_Annual_CTC'
  ];
  selectedIncrementOn: string = '';
  selectedVPProcess: string = ''; // Holds the selected value
  bloodGroups: string[] = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
  ];
  subDepartmentList = ['HR', 'Finance', 'Engineering', 'Marketing'];
  stateList = ['New York', 'California', 'Texas', 'Florida'];
  ratingList = ['Excellent', 'Good', 'Average', 'Below Average', 'Poor'];
  hodList = [
    { name: 'Alice Johnson', code: 'AJ001' },
    { name: 'Bob Williams', code: 'BW002' }
  ];
  bandList = ['Band 1', 'Band 2', 'Band 3'];
  gradeList = ['Grade A', 'Grade B', 'Grade C'];
  designationList = ['Manager', 'Senior Manager', 'Director'];
  managersList = [
    { name: 'John Doe', code: 'JD001' },
    { name: 'Jane Smith', code: 'JS002' }
  ];

  currencyList = [
    { value: 'USD', label: 'US Dollar (USD)' },
    { value: 'EUR', label: 'Euro (EUR)' },
    { value: 'GBP', label: 'British Pound (GBP)' },
    { value: 'INR', label: 'Indian Rupee (INR)' },
    { value: 'JPY', label: 'Japanese Yen (JPY)' },
    { value: 'AUD', label: 'Australian Dollar (AUD)' },
    { value: 'CAD', label: 'Canadian Dollar (CAD)' }
  ];



  // preventNegativeValues(event: KeyboardEvent) {
  //   if (event.key === '-' || event.key === 'e' || event.key === 'E') {
  //     event.preventDefault(); // Stops "-" and "e/E" from being typed
  //   }
  // }
  preventNegativeValues(event: KeyboardEvent) {
    const invalidChars = ['-', 'e', 'E', '+', '@', '#', '$', '%', '^', '&', '*', '(', ')', '=', '!', '_', '~', '`', '{', '}', '[', ']', ':', ';', '"', "'", '<', '>', ',', '?', '/', '\\', '|'];

    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block special characters
    }
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.getListCandidate();
      this.callAppdd();
      setTimeout(() => {

        this.getEmployeeList();
      }, 100)
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }

  allowOnlyDigits(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  preventMinus(event: KeyboardEvent): void {
    if (event.key === '-' || event.code === 'Minus') {
      event.preventDefault();
    }
  }
  disallowInvalidYearValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // Skip validation if empty (since it's not mandatory)
    if (!value) {
      return null;
    }

    // Must be exactly 4 digits
    if (!/^\d{4}$/.test(value)) {
      return { pattern: true };
    }

    // Disallow years starting with 00 (e.g., 0000–0099)
    if (/^00/.test(value)) {
      return { invalidYear: true };
    }

    return null;
  }



  filteredEmployees: any;
  employeeData: any;
  candidateGeneralAndSalaryinfo: any = [];
  candidateGeneralAndSalaryinfowithoutgeneralinfo: boolean = false;
  // getListCandidate() {
  //   this.httpService.callGetService(`${this.config.getListbyCandidateIdAndCompanyId}?candidateId=${this.candidateDetails.candidateId}&companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
  //     this.candidateGeneralAndSalaryinfo = data.data;
  //     console.log(data.data);

  //     this.candidateGeneralAndSalaryinfowithoutgeneralinfo =
  //       data.data.currentEmploymentFormByHR?.length > 0 &&
  //       data.data.candidateSalaryInformation?.length > 0;


  //     console.log(this.candidateGeneralAndSalaryinfowithoutgeneralinfo);

  //   })
  // }
  // getEmployeeList() {
  //   this.httpService.callGetService(`${this.config.candidateList}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
  //     this.filteredEmployees = record.data;


  //     let filterrecord = this.filteredEmployees.filter((record: any) => record.candidateId === this.candidateDetails.candidateId); // Initialize filtered list

  //     this.employeeData = filterrecord[0];


  //     let ForReportingManager = this.assignReporteesDropdown?.find((record: any) =>
  //       record.id === this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.[0]?.reportingManagerName
  //     );

  //     let ForHodName = this.assignReporteesDropdown?.find((record: any) =>
  //       record.id === this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.[0]?.hodName
  //     );
  //     let ForDottedManagerName = this.assignReporteesDropdown?.find((record: any) =>
      
       
        
  //        record.id === parseInt(this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.[0]?.dottedReportingManagerName)
  //     );
  //     console.log(ForDottedManagerName);
  //     console.log(this.employeeData);
      
  //     if (record?.data) {
  //       console.log(this.employeeData?.highestEducationMarks);
        
  //       this.employeeForm.patchValue({
  //         candidateId: this.employeeData?.record?.candidateId,
  //         salutation: this.candidateDetails?.salutation || '',
  //         firstName: this.candidateDetails?.firstName || '',
  //         lastName: this.candidateDetails?.lastName || '',
  //         genders: this.employeeData?.gender || '',
  //         country: this.employeeData?.country || '',
  //         presentAddress: this.employeeData?.address || '',
  //         permanentAddress: this.employeeData?.permanentAddress || '',
  //         maritalStatus: this.employeeData?.maritalStatus || '',
  //         dateOfBirth: this.employeeData?.dateOfBirth || '',
  //         age: this.employeeData?.age || '',
  //         personalEmail: this.candidateDetails?.candidateEmail || '',
  //         aadhaarCardNo: this.employeeData?.aadharNo || '',
  //         panNo: this.employeeData?.panNo || '',
  //         unaNo: this.employeeData?.uan || '',
  //         mobileNo: this.employeeData?.contactNo || '',
  //         previousExperience: this.employeeData?.totalExperience || '',
  //         emergencyContact: this.employeeData?.emergencyContactNo || '',
  //         bloodGroup: this.employeeData?.bloodGroup || '',
  //         fathersName: this.employeeData?.fathersName || '',
  //         mothersName: this.employeeData?.mothersName || '',
  //         spouseName: this.employeeData?.spouseName || '',
  //         noOfChildren: this.employeeData?.noOfChildren || '',
  //         relativeWorking: this.employeeData?.isRelativeWorking ? 'Yes' : 'No',
  //         highestEducation: this.employeeData?.highestEducationQualification,
  //         highestEducationInstitute: this.employeeData?.highestEducationInstitute || '',
  //         highestEducationMarks: this.employeeData?.highestEducationMarks || '',
  //         highestEducationYear: this.employeeData?.highestEducationYearOfPassing || '',
  //         secondEducation: this.employeeData?.highestEducationQualification2,
  //         secondEducationInstitute: this.employeeData?.highestEducationInstitute2 || '',
  //         secondEducationMarks: this.employeeData?.highestEducationMarks2 || '',
  //         secondEducationYear: this.employeeData?.highestEducationYearOfPassing2 || '',
  //         thirdEducation: this.employeeData?.highestEducationQualification3,
  //         thirdEducationInstitute: this.employeeData?.highestEducationInstitute3 || '',
  //         thirdEducationMarks: this.employeeData?.highestEducationMarks3 || '',
  //         thirdEducationYear: this.employeeData?.highestEducationYearOfPassing3 || '',

  //         highestProfessionalInstitute: this.employeeData?.highestProfessionalInstitute || '',
  //         highestProfessionalMarks: this.employeeData?.highestProfessionalMarks || '',
  //         highestProfessional: this.employeeData?.highestProfessionalQualification || '',
  //         highestProfessionalYear: this.employeeData?.highestProfessionalYearOfPassing || '',
  //         lastOrganisation: this.employeeData?.lastToLastOrganisationName,

  //         lastOrganisationDepartment: this.employeeData?.lastOrganisationDepartment,
  //         lastOrganisationDesignation: this.employeeData?.lastOrganisationDesignation,
  //         lastOrganisationJoiningDate: this.employeeData?.lastOrganisationDoj,
  //         lastOrganisationLastWorkingDate: this.employeeData?.lastOrganisationLwd,
  //         // lastToLastOrganisation: this.employeeData?.lastOrganisationName,
  //         lastToLastOrganisationDepartment: this.employeeData?.lastToLastOrganisationDepartment,
  //         lastToLastOrganisationDesignation: this.employeeData?.lastToLastOrganisationDesignation,
  //         lastToLastOrganisationJoiningDate: this.employeeData?.lastToLastOrganisationDoj,
  //         lastToLastOrganisationLastWorkingDate: this.employeeData?.lastToLastOrganisationLwd,
  //         lastToLastOrganisation: this.employeeData?.lastToLastOrganisationName,
  //         anyOtherOrganisation: this.employeeData?.otherOrganisationName,
  //         anyOtherOrganisationJoiningDate: this.employeeData?.otherOrganisationDoj,
  //         anyOtherOrganisationLastWorkingDate: this.employeeData?.otherOrganisationLwd,
  //         anyOtherOrganisationDepartment: this.employeeData?.otherOrganisationDepartment,
  //         anyOtherOrganisationDesignation: this.employeeData?.otherOrganisationDesignation,



  //         //-----------------------------------------------------------hr--------------------------------------------------------------
  //         employmentCategory: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.employmentCategory : '',
  //         employmentType: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.employmentType : '',
  //         retirementAge: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.retirementAge : '',
  //         empStatus: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.[0]?.empStatus || 'Active',
  //         dateOfJoining: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.dateOfJoining : '',
  //         groupName: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.groupName : '',
  //         companyName: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.companyName : '',
  //         reportingManagerName: ForReportingManager ? ForReportingManager?.name : this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.reportingManagerName,
  //         // reportingManagerName:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?String(this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.reportingManagerName):null,
  //         reportingManagerCode: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.reportingManagerCode : '',
  //         dottedReportingManagerName:ForDottedManagerName? ForDottedManagerName?.name : this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.dottedReportingManagerName ,
  //         dottedReportingManagerCode: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.dottedReportingManagerCode : '',
  //         hodName: ForHodName ? ForHodName?.name : this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.hodName,
  //         hodCode: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.hodCode : '',
  //         band: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.band : '',
  //         grade: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.grade : '',
  //         designation: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.designation : '',
  //         department: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.department : '',
  //         subDepartment: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.subDepartment : '',
  //         workLocationState: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.workLocationState : '',
  //         workLocationCity: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.workLocationCity : '',
  //         designationAtDoj: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.designationAtDoj : '',
  //         noOfPromotions: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.noOfPromotions : '',
  //         currentPerformanceScore: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.currentPerformanceScore : '',
  //         currentPerformanceRating: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.currentPerformanceRating : '',
  //         lastYearPerformanceScore: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.lastYearPerformanceScore : '',
  //         lastYearPerformanceRating: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.lastYearPerformanceRating : '',
  //         yearBeforeLastYearPerformanceScore: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.yearBeforeLastYearPerformanceScore : '',
  //         yearBeforeLastYearPerformanceRating: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR ? this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.yearBeforeLastYearPerformanceRating : '',

  //         //.............................................................saraly info.......................................................................

  //         currency: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.currency : '',
  //         salaryStatus: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.salaryStatus : '',
  //         bankName: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.bankName : '',
  //         bankBranchAddress: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.bankBranchAddress : '',
  //         bankAccount: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.bankAccount : '',
  //         ifscCode: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.ifscCode : '',

  //         effectiveDate: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.effectiveDate : '',
  //         basicSalaryPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.basicSalaryPm : '',
  //         daPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.daPm : '',
  //         hraPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.hraPm : '',
  //         otherAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.otherAllowancePm : '',
  //         ltaPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.ltaPm : '',
  //         medicalAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.medicalAllowancePm : '',
  //         washingAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.washingAllowancePm : '',
  //         specialAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.specialAllowancePm : '',
  //         fuelAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.fuelAllowancePm : '',
  //         entertainmentAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.entertainmentAllowancePm : '',
  //         educationAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.educationAllowancePm : '',
  //         booksAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.booksAllowancePm : '',
  //         statutoryBonusPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.statutoryBonusPm : '',
  //         anyOtherAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.anyOtherAllowancePm : '',
  //         grossSalaryPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.grossSalaryPm : '',
  //         employeePfPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.employeePfPm : '',
  //         employerPfPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.employerPfPm : '',
  //         ptPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.ptPm : '',
  //         lwfPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.lwfPm : '',
  //         esicPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.esicPm : '',
  //         otherRetiralPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.otherRetiralPm : '',
  //         totalRetiralPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.totalRetiralPm : '',
  //         totalCTCIncludingRetiralPM: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.totalCTCIncludingRetiralPM : '',
  //         totalCTCIncludingRetiralPA: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.totalCTCIncludingRetiralPA : '',
  //         processOfVp: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.processOfVp : '',
  //         annualVariablePayBudget: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.annualVariablePayBudget : '',
  //         annualTotalCtc: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.annualTotalCtc : '',
  //         incrementOn: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation ? this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.incrementOn : ''





  //       });
  //       console.log(this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.customValues);


  //       // this.customFieldData=this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.customValues.map((ele: any) => {
  //       //   return {
  //       //     ...fieldName,
  //       //      fieldId: ele?.fieldId,
  //       //      fieldName: ele.fieldName,
  //       //      fieldValue: ele.fieldValue??null,
  //       //      id: null
  //       //    }

  //       //  });

  //       console.log(this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.customValues);

  //       let fieldName = this.customFieldData;
  //       console.log(this.customFieldData);

  //       this.customFieldData = fieldName.map((elm: any) => {
  //         const matchData = this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.customValues
  //           ?.find((ele: any) => ele.fieldId === elm.fieldId);

  //         return {
  //           fieldId: elm?.fieldId,
  //           fieldName: elm?.fieldName,
  //           fieldValue: matchData?.fieldValue ?? null,
  //           id: null
  //         };
  //       });
  //       console.log(this.employeeForm.aadhaarCardNo);

  //       if (this.employeeForm.value?.aadhaarCardNo) {

  //         this.checkAadharNo();
  //       }
  //       if (this.employeeForm.value?.panNo) {

  //         this.checkPanNo();
  //       }
  //       if (this.employeeForm.value?.unaNo) {
  //         this.checkUanNo();
  //       }
  //       if (this.employeeForm.value?.mobileNo) {
  //         this.checkMobileNo();
  //       }
  //       // this.onBandChange(this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.band);

  //     } else {
  //       this.employeeForm.patchValue({

  //         salutation: this.candidateDetails?.salutation || '',
  //         firstName: this.candidateDetails?.firstName || '',
  //         lastName: this.candidateDetails?.lastName || '',
  //         personalEmail: this.candidateDetails?.candidateEmail || '',
  //         empStatus: 'Active',
  //       })
  //     }
  //     // this.callAppdd();
  //   })


  // }
getListCandidate() {
  this.httpService
    .callGetService(
      `${this.config.getListbyCandidateIdAndCompanyId}?candidateId=${this.candidateDetails.candidateId}&companyId=${this.loggedInUserCompanyID}`
    )
    .subscribe((data: any) => {
      this.candidateGeneralAndSalaryinfo = data.data;
      console.log("Candidate Data:", data.data);

      this.candidateGeneralAndSalaryinfowithoutgeneralinfo =
        data.data?.currentEmploymentFormByHR?.length > 0 &&
        data.data?.candidateSalaryInformation?.length > 0;

      console.log(
        "candidateGeneralAndSalaryinfowithoutgeneralinfo:",
        this.candidateGeneralAndSalaryinfowithoutgeneralinfo
      );

      // ✅ Ensure getEmployeeList runs only after candidate info is ready
      this.getEmployeeList();
    });
}

getEmployeeList() {
  this.httpService
    .callGetService(`${this.config.candidateList}/${this.loggedInUserCompanyID}`)
    .subscribe((record: any) => {
      this.filteredEmployees = record?.data || [];

      let filterrecord = this.filteredEmployees.filter(
        (rec: any) => rec.candidateId === this.candidateDetails?.candidateId
      );

      this.employeeData = filterrecord?.[0] || null;

      // ✅ Safe references for nested data
      const currentEmploymentFormByHR =
        this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.length > 0
          ? this.candidateGeneralAndSalaryinfo.currentEmploymentFormByHR[0]
          : null;

      const candidateSalaryInfo =
        this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation?.length > 0
          ? this.candidateGeneralAndSalaryinfo.candidateSalaryInformation[0]
          : null;

      let ForReportingManager = this.assignReporteesDropdown?.find(
        (rec: any) => rec.id === currentEmploymentFormByHR?.reportingManagerName
      );

      let ForHodName = this.assignReporteesDropdown?.find(
        (rec: any) => rec.id === currentEmploymentFormByHR?.hodName
      );

      let ForDottedManagerName = this.assignReporteesDropdown?.find(
        (rec: any) =>
          rec.id === parseInt(currentEmploymentFormByHR?.dottedReportingManagerName)
      );

      console.log("Dotted Manager:", ForDottedManagerName);
      console.log("Employee Data:", this.employeeData);

      if (record?.data) {
        this.employeeForm.patchValue({
          candidateId: this.employeeData?.record?.candidateId,
          salutation: this.candidateDetails?.salutation || '',
          firstName: this.candidateDetails?.firstName || '',
          lastName: this.candidateDetails?.lastName || '',
          genders: this.employeeData?.gender || '',
          country: this.employeeData?.country || '',
          presentAddress: this.employeeData?.address || '',
          permanentAddress: this.employeeData?.permanentAddress || '',
          maritalStatus: this.employeeData?.maritalStatus || '',
          dateOfBirth: this.employeeData?.dateOfBirth || '',
          age: this.employeeData?.age || '',
          personalEmail: this.candidateDetails?.candidateEmail || '',
          aadhaarCardNo: this.employeeData?.aadharNo || '',
          panNo: this.employeeData?.panNo || '',
          unaNo: this.employeeData?.uan || '',
          mobileNo: this.employeeData?.contactNo || '',
          previousExperience: this.employeeData?.totalExperience || '',
          emergencyContact: this.employeeData?.emergencyContactNo || '',
          bloodGroup: this.employeeData?.bloodGroup || '',
          fathersName: this.employeeData?.fathersName || '',
          mothersName: this.employeeData?.mothersName || '',
          spouseName: this.employeeData?.spouseName || '',
          noOfChildren: this.employeeData?.noOfChildren || '',
          relativeWorking: this.employeeData?.isRelativeWorking ? 'Yes' : 'No',
          highestEducation: this.employeeData?.highestEducationQualification,
          highestEducationInstitute: this.employeeData?.highestEducationInstitute || '',
          highestEducationMarks: this.employeeData?.highestEducationMarks || '',
          highestEducationYear: this.employeeData?.highestEducationYearOfPassing || '',
          secondEducation: this.employeeData?.highestEducationQualification2,
          secondEducationInstitute: this.employeeData?.highestEducationInstitute2 || '',
          secondEducationMarks: this.employeeData?.highestEducationMarks2 || '',
          secondEducationYear: this.employeeData?.highestEducationYearOfPassing2 || '',
          thirdEducation: this.employeeData?.highestEducationQualification3,
          thirdEducationInstitute: this.employeeData?.highestEducationInstitute3 || '',
          thirdEducationMarks: this.employeeData?.highestEducationMarks3 || '',
          thirdEducationYear: this.employeeData?.highestEducationYearOfPassing3 || '',

          highestProfessionalInstitute: this.employeeData?.highestProfessionalInstitute || '',
          highestProfessionalMarks: this.employeeData?.highestProfessionalMarks || '',
          highestProfessional: this.employeeData?.highestProfessionalQualification || '',
          highestProfessionalYear: this.employeeData?.highestProfessionalYearOfPassing || '',
          lastOrganisation: this.employeeData?.lastToLastOrganisationName,
          lastOrganisationDepartment: this.employeeData?.lastOrganisationDepartment,
          lastOrganisationDesignation: this.employeeData?.lastOrganisationDesignation,
          lastOrganisationJoiningDate: this.employeeData?.lastOrganisationDoj,
          lastOrganisationLastWorkingDate: this.employeeData?.lastOrganisationLwd,
          lastToLastOrganisation: this.employeeData?.lastToLastOrganisationName,
          lastToLastOrganisationDepartment: this.employeeData?.lastToLastOrganisationDepartment,
          lastToLastOrganisationDesignation: this.employeeData?.lastToLastOrganisationDesignation,
          lastToLastOrganisationJoiningDate: this.employeeData?.lastToLastOrganisationDoj,
          lastToLastOrganisationLastWorkingDate: this.employeeData?.lastToLastOrganisationLwd,
          anyOtherOrganisation: this.employeeData?.otherOrganisationName,
          anyOtherOrganisationJoiningDate: this.employeeData?.otherOrganisationDoj,
          anyOtherOrganisationLastWorkingDate: this.employeeData?.otherOrganisationLwd,
          anyOtherOrganisationDepartment: this.employeeData?.otherOrganisationDepartment,
          anyOtherOrganisationDesignation: this.employeeData?.otherOrganisationDesignation,

          // ------------------------------------------------ HR ------------------------------------------------
          employmentCategory: currentEmploymentFormByHR?.employmentCategory || '',
          employmentType: currentEmploymentFormByHR?.employmentType || '',
          retirementAge: currentEmploymentFormByHR?.retirementAge || '',
          empStatus: currentEmploymentFormByHR?.empStatus || 'Active',
          dateOfJoining: currentEmploymentFormByHR?.dateOfJoining || '',
          groupName: currentEmploymentFormByHR?.groupName || '',
          companyName: currentEmploymentFormByHR?.companyName || '',
          reportingManagerName: ForReportingManager?.name || currentEmploymentFormByHR?.reportingManagerName,
          reportingManagerCode: currentEmploymentFormByHR?.reportingManagerCode || '',
          dottedReportingManagerName: ForDottedManagerName?.name || currentEmploymentFormByHR?.dottedReportingManagerName,
          dottedReportingManagerCode: currentEmploymentFormByHR?.dottedReportingManagerCode || '',
          hodName: ForHodName?.name || currentEmploymentFormByHR?.hodName,
          hodCode: currentEmploymentFormByHR?.hodCode || '',
          band: currentEmploymentFormByHR?.band || '',
          grade: currentEmploymentFormByHR?.grade || '',
          designation: currentEmploymentFormByHR?.designation || '',
          department: currentEmploymentFormByHR?.department || '',
          subDepartment: currentEmploymentFormByHR?.subDepartment || '',
          workLocationState: currentEmploymentFormByHR?.workLocationState || '',
          workLocationCity: currentEmploymentFormByHR?.workLocationCity || '',
          designationAtDoj: currentEmploymentFormByHR?.designationAtDoj || '',
          noOfPromotions: currentEmploymentFormByHR?.noOfPromotions || '',
          currentPerformanceScore: currentEmploymentFormByHR?.currentPerformanceScore || '',
          currentPerformanceRating: currentEmploymentFormByHR?.currentPerformanceRating || '',
          lastYearPerformanceScore: currentEmploymentFormByHR?.lastYearPerformanceScore || '',
          lastYearPerformanceRating: currentEmploymentFormByHR?.lastYearPerformanceRating || '',
          yearBeforeLastYearPerformanceScore: currentEmploymentFormByHR?.yearBeforeLastYearPerformanceScore || '',
          yearBeforeLastYearPerformanceRating: currentEmploymentFormByHR?.yearBeforeLastYearPerformanceRating || '',

          // ------------------------------------------------ Salary Info ------------------------------------------------
          currency: candidateSalaryInfo?.currency || '',
          salaryStatus: candidateSalaryInfo?.salaryStatus || '',
          bankName: candidateSalaryInfo?.bankName || '',
          bankBranchAddress: candidateSalaryInfo?.bankBranchAddress || '',
          bankAccount: candidateSalaryInfo?.bankAccount || '',
          ifscCode: candidateSalaryInfo?.ifscCode || '',
          effectiveDate: candidateSalaryInfo?.effectiveDate || '',
          basicSalaryPm: candidateSalaryInfo?.basicSalaryPm || '',
          daPm: candidateSalaryInfo?.daPm || '',
          hraPm: candidateSalaryInfo?.hraPm || '',
          otherAllowancePm: candidateSalaryInfo?.otherAllowancePm || '',
          ltaPm: candidateSalaryInfo?.ltaPm || '',
          medicalAllowancePm: candidateSalaryInfo?.medicalAllowancePm || '',
          washingAllowancePm: candidateSalaryInfo?.washingAllowancePm || '',
          specialAllowancePm: candidateSalaryInfo?.specialAllowancePm || '',
          fuelAllowancePm: candidateSalaryInfo?.fuelAllowancePm || '',
          entertainmentAllowancePm: candidateSalaryInfo?.entertainmentAllowancePm || '',
          educationAllowancePm: candidateSalaryInfo?.educationAllowancePm || '',
          booksAllowancePm: candidateSalaryInfo?.booksAllowancePm || '',
          statutoryBonusPm: candidateSalaryInfo?.statutoryBonusPm || '',
          anyOtherAllowancePm: candidateSalaryInfo?.anyOtherAllowancePm || '',
          grossSalaryPm: candidateSalaryInfo?.grossSalaryPm || '',
          employeePfPm: candidateSalaryInfo?.employeePfPm || '',
          employerPfPm: candidateSalaryInfo?.employerPfPm || '',
          ptPm: candidateSalaryInfo?.ptPm || '',
          lwfPm: candidateSalaryInfo?.lwfPm || '',
          esicPm: candidateSalaryInfo?.esicPm || '',
          otherRetiralPm: candidateSalaryInfo?.otherRetiralPm || '',
          totalRetiralPm: candidateSalaryInfo?.totalRetiralPm || '',
          totalCTCIncludingRetiralPM: candidateSalaryInfo?.totalCTCIncludingRetiralPM || '',
          totalCTCIncludingRetiralPA: candidateSalaryInfo?.totalCTCIncludingRetiralPA || '',
          processOfVp: candidateSalaryInfo?.processOfVp || '',
          annualVariablePayBudget: candidateSalaryInfo?.annualVariablePayBudget || '',
          annualTotalCtc: candidateSalaryInfo?.annualTotalCtc || '',
          incrementOn: candidateSalaryInfo?.incrementOn || '',
        });

        // ✅ Safely handle custom fields
        let fieldName = this.customFieldData || [];
        this.customFieldData = fieldName.map((elm: any) => {
          const matchData = candidateSalaryInfo?.customValues?.find(
            (ele: any) => ele.fieldId === elm.fieldId
          );
          return {
            fieldId: elm?.fieldId,
            fieldName: elm?.fieldName,
            fieldValue: matchData?.fieldValue ?? null,
            id: null,
          };
        });

        // ✅ Validation checks
        if (this.employeeForm.value?.aadhaarCardNo) this.checkAadharNo();
        if (this.employeeForm.value?.panNo) this.checkPanNo();
        if (this.employeeForm.value?.unaNo) this.checkUanNo();
        if (this.employeeForm.value?.mobileNo) this.checkMobileNo();
      } else {
        this.employeeForm.patchValue({
          salutation: this.candidateDetails?.salutation || '',
          firstName: this.candidateDetails?.firstName || '',
          lastName: this.candidateDetails?.lastName || '',
          personalEmail: this.candidateDetails?.candidateEmail || '',
          empStatus: 'Active',
        });
      }
    });
}

  isCompanyNameTooLong(fieldName:any): boolean {
    const value = this.employeeForm.get(fieldName)?.value;
  
    return typeof value?.label === 'string' && value?.label.length > 255;
  }


  hasError(controlName: string, errorType: string) {
    const control = this.employeeForm.get(controlName);
    return control?.hasError(errorType) && (control.touched || control.dirty);
  }
  subDepartment: any
  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close('Form Saved');
  }

  addDeptAndLoc(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '60%';
    dialogConfig.data = {
      popupName: popupName,
      // employeeData: this.getEmployeeCodeDataList
      employeeData: "this.getEmployeeCodeDataList"
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddDeptLocComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      this.getDepartmentsByCompany();
    });
  }
  getListOfBandNameOfComp: any = [];
  getListOfGradeNameOfComp: any = [];
  getListOfDesignationsOfComp: any = [];
  getListOfDepartmentsOfComp: any = [];
  getListOfSubDepartmentsOfComp: any = [];
  getListOfDesignationsAtDOJOfComp: any = []
  assignReporteesDropdown: any = [];
  getAllEmployeeofCompany: any = [];
  getListOfCompanyNameOfComp: any = []
  callAppdd() {
    this.getAllEmployeeDropdownByCompanyID();
    this.getBandsByCompany();
    this.getBAndAndGrade();
    this.getGradeByCompany();
    this.getDesignationsByCompany();

    this.getDepartmentsByCompany();
    this.getSubDepartmentByCompany();
    this.getDesignationsAtDOJByCompany();
    this.getCompanyNameByCompany();
    this.getLocationListForPrifix();
    this.getAllEmployeeCodeData();
    this.getBankNameByCompany();
    this.getEmployeeListCode();
    this.getGroupNameByCompany();
  }
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getAllEmployeeofCompany = [];
        this.assignReporteesDropdown = [];
        data?.data?.users.forEach((ele: any) => {
          if (ele) {
            let obj = {
              id: ele.id,
              name: ele.firstName + ' ' + ele.lastName,
              empCode: ele.empCode
            }
            this.assignReporteesDropdown.push(obj);
          }
        });
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          }
          this.getAllEmployeeofCompany.push(obj);
        });

      }, (error: any) => {
      }, () => { });
  }
  gradeAndBandData: any
  getBAndAndGrade() {
    this.httpService.callGetService(`${this.config.getBandAndGradeForProbation}?companyId=${this.loggedInUserCompanyID}`)
      .subscribe((record: any) => {
        console.log("record" + record.data);

        this.gradeAndBandData = record.data;

        record?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.band,
            name: ele.band,
          }
          this.getListOfBandNameOfComp.push(obj);
        });
        this.getListOfBandNameOfComp = this.getListOfBandNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));

        //  --------------------------------------------------------------grade----------------------------------------------------------

      })


  }
  onBandChange(event: any) {

    this.employeeForm.get('grade')?.reset();
    this.getListOfGradeNameOfComp = [];
    let filterband = []
    filterband = this.gradeAndBandData.filter((elm: any) => elm.band == event)



    filterband[0]?.grades?.forEach((ele: any) => {
      let obj = {
        id: ele,
        name: ele,
      }
      this.getListOfGradeNameOfComp.push(obj);
    });
    this.getListOfGradeNameOfComp = this.getListOfGradeNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));

  }
  getBandsByCompany() {
    // this.httpService.callGetService(this.config.getBandsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
    //   this.getListOfBandNameOfComp = [];
    //   data?.data?.forEach((ele: any) => {
    //     let obj = {
    //       id: ele,
    //       name: ele,
    //     }
    //     this.getListOfBandNameOfComp.push(obj);
    //   });
    //   this.getListOfBandNameOfComp = this.getListOfBandNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    // })
  }
  getGradeByCompany() {
    // this.httpService.callGetService(this.config.getGradesByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
    //   this.getListOfGradeNameOfComp = [];
    //   data?.data?.forEach((ele: any) => {
    //     let obj = {
    //       id: ele,
    //       name: ele,
    //     }
    //     this.getListOfGradeNameOfComp.push(obj);
    //   });
    //   this.getListOfGradeNameOfComp = this.getListOfGradeNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    // })
  }
  getDesignationsByCompany() {
    console.log("jfgjfgfd");

    this.httpService.callGetService(this.config.getDesignationsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsOfComp.push(obj);
      });
      this.getListOfDesignationsOfComp = this.getListOfDesignationsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
      console.log(this.getListOfDesignationsOfComp);

    })
  }
  // getDepartmentsByCompany() {
  //   this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.getListOfDepartmentsOfComp = [];
  //     data?.data?.forEach((ele: any) => {
  //       let obj = {
  //         id: ele,
  //         name: ele,
  //       }
  //       this.getListOfDepartmentsOfComp.push(obj);
  //     });
  //     this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
  //   })
  // }

  arrAllDepartmentCode: any = [];
  deptrecord: any = []
  CombineDeptArray: any = []
  tableDataForDept: any = [];
  updatedListData: any = [];
  DeptNewAddedrecord: any = [];
  getDepartmentsByCompany() {



    this.httpService.callGetService(`${this.config.getDepartmentListForELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`,).subscribe((resp: any) => {
      this.arrAllDepartmentCode = [];
      this.arrAllDepartmentCode = resp.data;

    })
    setTimeout(() => {

      // this.httpService.callGetService(`${this.config.getDepartment}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
      this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((record: any) => {
        this.deptrecord = record.data;
        this.tableDataForDept = this.deptrecord.map((elm: any) => {
          const department = elm; // Ensure department is a valid any
          return {
            department: department, // Ensure the department is assigned properly
            deptCode: null, // Assign extracted two-letter code
            finalCode: null, // Assign extracted two-letter code
          };
        });


        this.updatedListData = this.tableDataForDept?.map((dept: any) => {

          const deptNames = this.tableDataForDept?.map((d: any) => d.department) || []; // Extract department names from dept array

          // Filter departments that are in NotmatchingData but NOT in deptNames
          const data = this.arrAllDepartmentCode?.filter((elm: any) => !deptNames.includes(elm?.departmentName));

          this.DeptNewAddedrecord = data?.map((elm: any) => {
            return {
              department: elm?.departmentName, // Ensure the department is assigned properly
              deptCode: elm?.departmentPrefix, // Assign extracted two-letter code
              departmentId: elm?.departmentId,
            }

          })
          const matchingData = this.arrAllDepartmentCode?.find((data: any) => data?.departmentName === dept?.department);


          // Update the limit for the matching band or set it to null for non-matching bands
          return {
            ...dept,
            // department: matchingBand ? matchingBand.departmentName : null,

            departmentId: matchingData ? matchingData?.departmentId : null,
            deptCode: matchingData ? matchingData?.departmentPrefix : null,
            finalCode: matchingData ? matchingData?.finalCode : null, // Use amountLimit if matching, otherwise null
          };
        });
        this.CombineDeptArray = [
          ...(this.updatedListData || []),
          ...(this.DeptNewAddedrecord || [])
        ];


      })


    }, 100)
    // console.log(this.updatetableDataForLoca);

  }
  getBankNameList: any = []
  getBankNameByCompany() {
    this.httpService.callGetService(this.config.getBankNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getBankNameList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBankNameList.push(obj);
      });
      this.getBankNameList = this.getBankNameList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCompanyNameByCompany() {
    this.httpService.callGetService(this.config.getCompanyNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCompanyNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCompanyNameOfComp.push(obj);
      });
      this.getListOfCompanyNameOfComp = this.getListOfCompanyNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getSubDepartmentByCompany() {
    this.httpService.callGetService(this.config.getSubDepartmentByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfSubDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfSubDepartmentsOfComp.push(obj);
      });
      this.getListOfSubDepartmentsOfComp = this.getListOfSubDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  states: string[] = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
    'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim',
    'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
    'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep',
    'Delhi', 'Puducherry', 'Ladakh', 'Jammu and Kashmir'
  ];
  getDesignationsAtDOJByCompany() {
    this.httpService.callGetService(this.config.getDesignationsAtDOJByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsAtDOJOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsAtDOJOfComp.push(obj);
      });
      this.getListOfDesignationsAtDOJOfComp = this.getListOfDesignationsAtDOJOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }

  getListOfGroupNameOfComp: any = []
  getGroupNameByCompany() {
    this.httpService.callGetService(this.config.getGroupNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGroupNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGroupNameOfComp.push(obj);
      });
      this.getListOfGroupNameOfComp = this.getListOfGroupNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }

  arrAllLocationList: any = []
  getLocationListForPrifix() {
    this.httpService.callGetService(`${this.config.getLocationListForELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`,).subscribe((resp: any) => {
      this.arrAllLocationList = [];
      console.log(resp.data);
      this.arrAllLocationList = resp.data;

    })
  }

  getEmployeeCodeDataList: any = [];
  selectedDeptLocation: any;
  getAllEmployeeCodeData() {
    this.httpService.callGetService(`${this.config.getAllEmployeeCode}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`).subscribe((resp: any) => {
      this.getEmployeeCodeDataList = resp?.data[0];
      this.setPrefix = this.getEmployeeCodeDataList?.companyPrefix;
      this.setLimit = this.getEmployeeCodeDataList?.startNumber;
      this.isManual = this.getEmployeeCodeDataList?.isManual;
      this.selectedDeptLocation = this.getEmployeeCodeDataList?.employeeCodeSelection;
    })
  }

  onSelectionOfHod() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeeForm.controls['hodName'].value);
    this.employeeForm.controls['hodCode'].setValue(data?.empCode);
  }
  onSelectionOfManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeeForm.controls['reportingManagerName'].value);
    this.employeeForm.controls['reportingManagerCode'].setValue(data?.empCode);
  }
  onSelectionOfDottedManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeeForm.controls['dottedReportingManagerName'].value);
    this.employeeForm.controls['dottedReportingManagerCode'].setValue(data?.empCode);
  }
  addSubmitForm: boolean = false;
  showErrorMsgOfExistAccountNo: boolean = false
  checkAccountNo() {
    const accountControl = this.employeeForm.get('bankAccount');
    const accountValue = accountControl?.value;

    if (accountValue != null && accountValue !== '') {
      const request = {
        field: accountValue
      };

      this.httpService.callPostService(this.config.checkAccountNo, request)
        .subscribe(
          (data: any) => {
            if (data?.data) {
              this.showErrorMsgOfExistAccountNo = true;

              // Set custom error on control
              const existingErrors = accountControl?.errors || {};
              accountControl?.setErrors({ ...existingErrors, existAccountNo: true });
            } else {
              this.showErrorMsgOfExistAccountNo = false;

              // Remove only existAccountNo error
              const errors = accountControl?.errors;
              if (errors) {
                delete errors.existAccountNo;
                if (Object.keys(errors).length === 0) {
                  accountControl?.setErrors(null);
                } else {
                  accountControl?.setErrors(errors);
                }
              }
            }
          },
          (error: any) => {
            // Handle API error if needed
          }
        );
    }
  }


  showErrorMsgOfExistPAN: boolean = false
  checkPanNo() {
    const panControl = this.employeeForm.get('panNo');
    const panValue = panControl?.value;

    if (panValue != null && panValue !== '') {
      const request = {
        field: panValue
      };

      this.httpService.callPostService(this.config.checkPanNo, request)
        .subscribe(
          (data: any) => {
            if (data?.data) {
              this.showErrorMsgOfExistPAN = true;

              // Add custom error to the control
              const existingErrors = panControl?.errors || {};
              panControl?.setErrors({ ...existingErrors, existPAN: true });
            } else {
              this.showErrorMsgOfExistPAN = false;

              // Remove only existPAN error
              const errors = panControl?.errors;
              if (errors) {
                delete errors.existPAN;
                if (Object.keys(errors).length === 0) {
                  panControl?.setErrors(null);
                } else {
                  panControl?.setErrors(errors);
                }
              }
            }
          },
          (error: any) => {
            // Handle API error if needed
          }
        );
    }
  }

  showErrorMsgOfExistUAN: boolean = false
  checkUanNo() {
    const uanControl = this.employeeForm.get('unaNo'); // Check spelling: "unaNo" or "uanNo"
    const uanValue = uanControl?.value;

    if (uanValue != null && uanValue !== '') {
      const request = {
        field: uanValue
      };

      this.httpService.callPostService(this.config.checkUanNo, request)
        .subscribe(
          (data: any) => {
            if (!data?.status) {
              this.showErrorMsgOfExistUAN = true;

              // Set custom error on the form control
              const existingErrors = uanControl?.errors || {};
              uanControl?.setErrors({ ...existingErrors, existUAN: true });
            } else {
              this.showErrorMsgOfExistUAN = false;

              // Remove only the custom existUAN error
              const errors = uanControl?.errors;
              if (errors) {
                delete errors.existUAN;
                if (Object.keys(errors).length === 0) {
                  uanControl?.setErrors(null);
                } else {
                  uanControl?.setErrors(errors);
                }
              }
            }
          },
          (error: any) => {
            // Optional: handle backend/API errors
          }
        );
    }
  }

  showErrorMsgOfExistMobileNo: boolean = false
  checkMobileNo() {
    const mobileControl = this.employeeForm.get('mobileNo');
    const mobileValue = mobileControl?.value;

    if (mobileValue != null && mobileValue !== '') {
      const request = {
        field: mobileValue
      };

      this.httpService.callPostService(this.config.checkMobileNo, request)
        .subscribe(
          (data: any) => {
            if (!data?.status) {
              this.showErrorMsgOfExistMobileNo = true;

              // Merge with existing errors
              const existingErrors = mobileControl?.errors || {};
              mobileControl?.setErrors({ ...existingErrors, existMobileNo: true });
            } else {
              this.showErrorMsgOfExistMobileNo = false;

              // Remove only existMobileNo error
              const errors = mobileControl?.errors;
              if (errors) {
                delete errors.existMobileNo;
                if (Object.keys(errors).length === 0) {
                  mobileControl?.setErrors(null);
                } else {
                  mobileControl?.setErrors(errors);
                }
              }
            }
          },
          (error: any) => {
            // Handle error if needed
          }
        );
    }
  }


  showErrorMsgOfExistAddharNo: boolean = false
  checkAadharNo() {
    const aadharControl = this.employeeForm.get('aadhaarCardNo');

    const request = {
      field: aadharControl?.value
    };

    this.httpService.callPostService(this.config.checkAadharNo, request)
      .subscribe(
        (data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistAddharNo = true;
            const existingErrors = aadharControl?.errors || {};
            aadharControl?.setErrors({ ...existingErrors, existAadharNo: true });
          } else {
            this.showErrorMsgOfExistAddharNo = false;

            // ✅ Remove custom error only
            const errors = aadharControl?.errors;
            if (errors) {
              delete errors.existAadharNo;
              if (Object.keys(errors).length === 0) {
                aadharControl?.setErrors(null);
              } else {
                aadharControl?.setErrors(errors);
              }
            }
          }
        },
        (error: any) => {
          // Optional error handling
        }
      );
  }

  @ViewChild('formContainer') formContainer!: ElementRef;
  scrollToFirstInvalidControl() {
    // Template Ref Variable #formContainer
    const firstInvalidControl: HTMLElement = this.formContainer.nativeElement.querySelector('form .ng-invalid') as HTMLElement;
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }
areAnyFieldsTooLong(): boolean {
  const fieldsToCheck = ['companyName', 'bankName','band','grade','department','workLocationState','designationAtDoj','groupName','designation']; // add fields here
  return fieldsToCheck.some(field => this.isCompanyNameTooLong(field));
}
  SaveCurrentemployeerelatedInfo() {
    let data = this.employeeForm.value;
    console.log(this.employeeForm.controls)

    if (this.employeeForm.invalid || this.showErrorMsgOfExistAccountNo || this.showErrorMsgOfExistAddharNo || this.showErrorMsgOfExistPAN || this.showErrorMsgOfExistMobileNo || this.showErrorMsgOfExistUAN||this.areAnyFieldsTooLong()) {
      this.addSubmitForm = true;
      this.employeeForm.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return
    }



    console.log(this.loggedInUserCompanyID);
    let depetMent = data.department?.label || data.department

    const formData = this.employeeForm.value;
    console.log(formData);


    const payload = {
      companyId: this.loggedInUserCompanyID,
      candidateId: this.candidateDetails.candidateId,
      salutation: formData.salutation,
      firstName: formData.firstName,
      lastName: formData.lastName,
      year: this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
      hrId: this.loggedInUserId,
      gender: formData.genders,



      address: formData.presentAddress,
      permanentAddress: formData.permanentAddress,
      country: formData.country,
      maritalStatus: formData.maritalStatus || null,
      dateOfBirth: data?.dateOfBirth ? formatDateToLocalIso(new Date(data?.dateOfBirth)) : '',
      age: formData.age,
      aadharNo: formData.aadhaarCardNo,
      panNo: formData.panNo,
      uan: formData.unaNo || null,
      contactNo: formData.mobileNo,
      totalExperience: formData.previousExperience,
      emergencyContactNo: formData.emergencyContact,
      bloodGroup: formData.bloodGroup,
      fathersName: formData.fathersName,
      mothersName: formData.mothersName,
      spouseName: formData.spouseName,
      noOfChildren: formData.noOfChildren,
      isRelativeWorking: formData.relativeWorking === 'true' || formData.relativeWorking === true,

      // Education Information
      highestEducationQualification: formData.highestEducation,
      highestEducationInstitute: formData.highestEducationInstitute,
      highestEducationYearOfPassing: formData.highestEducationYear,
      highestEducationMarks: formData.highestEducationMarks,

      highestEducationQualification2: formData.secondEducation,
      highestEducationInstitute2: formData.secondEducationInstitute,
      highestEducationYearOfPassing2: formData.secondEducationYear,
      highestEducationMarks2: formData.secondEducationMarks,

      highestEducationQualification3: formData.thirdEducation,
      highestEducationInstitute3: formData.thirdEducationInstitute,
      highestEducationYearOfPassing3: formData.thirdEducationYear,
      highestEducationMarks3: formData.thirdEducationMarks,

      highestProfessionalQualification: formData.highestProfessional,
      highestProfessionalInstitute: formData.highestProfessionalInstitute,
      highestProfessionalYearOfPassing: formData.highestProfessionalYear,
      highestProfessionalMarks: formData.highestProfessionalMarks,

      // Prior Employment Information
      lastOrganisationName: formData.lastOrganisation,
      lastOrganisationDoj: formData.lastOrganisationJoiningDate ? formatDateToLocalIso(new Date(formData.lastOrganisationJoiningDate)) : '',
      lastOrganisationLwd: formData.lastOrganisationLastWorkingDate ? formatDateToLocalIso(new Date(formData.lastOrganisationLastWorkingDate)) : '',
      lastOrganisationDepartment: formData.lastOrganisationDepartment,
      lastOrganisationDesignation: formData.lastOrganisationDesignation,
      lastToLastOrganisationName: formData.lastToLastOrganisation,
      lastToLastOrganisationDoj: formData.lastToLastOrganisationJoiningDate ? formatDateToLocalIso(new Date(formData.lastToLastOrganisationJoiningDate)) : '',
      lastToLastOrganisationLwd: formData.lastToLastOrganisationLastWorkingDate ? formatDateToLocalIso(new Date(formData.lastToLastOrganisationLastWorkingDate)) : '',
      lastToLastOrganisationDepartment: formData.lastToLastOrganisationDepartment,
      lastToLastOrganisationDesignation: formData.lastToLastOrganisationDesignation,
      otherOrganisationName: formData.anyOtherOrganisation,
      otherOrganisationDoj: formData.anyOtherOrganisationJoiningDate ? formatDateToLocalIso(new Date(formData.anyOtherOrganisationJoiningDate)) : '',
      otherOrganisationLwd: formData.anyOtherOrganisationLastWorkingDate ? formatDateToLocalIso(new Date(formData.anyOtherOrganisationLastWorkingDate)) : '',
      otherOrganisationDepartment: formData.anyOtherOrganisationDepartment,
      otherOrganisationDesignation: formData.anyOtherOrganisationDesignation
    }
    let ForReportingManager = this.assignReporteesDropdown?.find((record: any) => record.id == data?.reportingManagerName);
    let ForHodName = this.assignReporteesDropdown?.find((record: any) => record.id == data?.hodName);

    let fromData = {
      fiscalYear: this.loggedInCompanyFiscalyear,
      year: this.selectedYearForCompetency,
      companyId: this.loggedInUserCompanyID,
      candidateId: this.candidateDetails?.candidateId ?? null,
      employmentCategory: data?.employmentCategory ?? null,
      employmentType: data?.employmentType ?? null,
      retirementAge: data?.retirementAge ?? null,
      empStatus: data?.empStatus ?? null,
      dateOfJoining: formatDate(data?.dateOfJoining, 'yyyy-MM-dd', 'en-US') ?? null,
      groupName: data?.groupName?.label ?? data?.groupName ?? null,
      companyName: data?.companyName?.label ?? data?.companyName ?? null,
      reportingManagerName: ForReportingManager?.name || data?.reportingManagerName,
      reportingManagerCode: data?.reportingManagerCode ?? null,
      dottedReportingManagerName: data?.dottedReportingManagerName,
      dottedReportingManagerCode: data?.dottedReportingManagerCode ?? null,
      hodName: ForHodName?.name || data?.hodName,
      hodCode: data?.hodCode ?? null,
      band: data?.band?.label?.trim() ?? data?.band?.trim() ?? null,
      grade: data?.grade?.label?.trim() ?? data?.grade?.trim() ?? null,
      designation: data?.designation?.label ?? data?.designation ?? null,
      department: depetMent ?? null, // Ensure `depetMent` is defined in the scope
      subDepartment: data?.subDepartment ?? null,
      workLocationState: data?.workLocationState?.label ?? data?.workLocationState ?? null,
      workLocationCity: data?.workLocationCity ?? null,
      designationAtDoj: data?.designationAtDoj?.label ?? data?.designationAtDoj ?? null,
      noOfPromotions: data?.noOfPromotions ?? null,
      currentPerformanceScore: data?.currentPerformanceScore ?? null,
      currentPerformanceRating: data?.currentPerformanceRating ?? null,
      lastYearPerformanceScore: data?.lastYearPerformanceScore ?? null,
      lastYearPerformanceRating: data?.lastYearPerformanceRating ?? null,
      yearBeforeLastYearPerformanceScore: data?.yearBeforeLastYearPerformanceScore ?? null,
      yearBeforeLastYearPerformanceRating: data?.yearBeforeLastYearPerformanceRating ?? null,
      mailBody: "Please review the submitted form for further processing.",
      mailSubject: "Candidate Employment Form Submission"
    };

    let banckName = data.bankName?.label || data.bankName
    let fromDataForSalary = {

      "hrId": this.loggedInUserId,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYearForCompetency,
      "companyId": this.loggedInUserCompanyID,
      "candidateId": this.candidateDetails.candidateId,
      "currency": data.currency,
      "salaryStatus": data.salaryStatus,
      "bankName": banckName,
      "bankBranchAddress": data.bankBranchAddress,
      "bankAccount": data.bankAccount,
      "ifscCode": data.ifscCode,
 "effectiveDate": data?.effectiveDate ? formatDate(data?.effectiveDate, 'yyyy-MM-dd', 'en-US') : null,
      "basicSalaryPm": data.basicSalaryPm,
      "customValues": this.customFieldData,
      "daPm": data.daPm,
      "hraPm": data.hraPm,
      "otherAllowancePm": data.otherAllowancePm,
      "ltaPm": data.ltaPm,
      "medicalAllowancePm": data.medicalAllowancePm,
      "washingAllowancePm": data.washingAllowancePm,
      "specialAllowancePm": data.specialAllowancePm,
      "fuelAllowancePm": data.fuelAllowancePm,
      "entertainmentAllowancePm": data.entertainmentAllowancePm,
      "educationAllowancePm": data.educationAllowancePm,
      "booksAllowancePm": data.booksAllowancePm,
      "statutoryBonusPm": data.statutoryBonusPm,
      "anyOtherAllowancePm": data.anyOtherAllowancePm,
      "grossSalaryPm": data.grossSalaryPm,
      "employeePfPm": data.employeePfPm,
      "employerPfPm": data.employerPfPm,
      "ptPm": data.ptPm,
      "lwfPm": data.lwfPm,
      "esicPm": data.esicPm,
      "otherRetiralPm": data.otherRetiralPm,
      "totalRetiralPm": data.totalRetiralPm,
      "totalCTCIncludingRetiralPM": data.totalCTCIncludingRetiralPM,
      "totalCTCIncludingRetiralPA": data.totalCTCIncludingRetiralPA,
      "processOfVp": data.processOfVp,
      "annualVariablePayBudget": data.annualVariablePayBudget,
      "annualTotalCtc": data.annualTotalCtc,
      "incrementOn": data.incrementOn,

    }
    console.log(data.bankName);

    if (this.employeeForm.valid) {
      // Step 1: Add Employee
      this.httpService.callPostService(this.config.addEmployeeDataByHR, payload).subscribe(
        (addEmpRes: any) => {
          const filterDept = this.arrAllDepartmentCode?.find(
            (elm: any) => elm?.departmentName === this.employeeForm.value.department
          );
          const filterLocation = this.arrAllLocationList?.find(
            (elm: any) => elm?.locationName === this.employeeForm.value.workLocationState
          );

          // ✅ Helper function to generate employee code
          const generateEmployeeCode = () => {
            if (!this.isManual) {
              const employeecodeFromData = {
                companyId: this.loggedInUserCompanyID,
                changeByUserId: this.loggedInUserId,
                companyCodeId: this.getEmployeeCodeDataList?.companyCodeId,
                manual: false,
                employeeCodeSelection: this.selectedDeptLocation,
                prefix: this.setPrefix,
                locationName: filterLocation?.locationName || null,
                departmentName: filterDept?.departmentName || null,
                startNumber: this.setLimit,
                locationCode: filterLocation?.locationPrefix || null,
                departmentCode: filterDept?.departmentPrefix || null,
                candidateId: this.candidateDetails?.candidateId,
                year: this.selectedYearForCompetency,
                fiscalYear: this.loggedInCompanyFiscalyear
              };
              this.httpService.callPostService(this.config.employeeFinalCode, employeecodeFromData).subscribe();
            }
          };

          // ✅ Helper function to create salary
          const createSalary = () => {
            this.httpService.callPostService(this.config.createByHRsalary, fromDataForSalary).subscribe(
              (salaryRes: any) => {
                const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: salaryRes.message,
                    btn2: 'OK',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  }
                });
                dialogRef.afterClosed().subscribe(() => {
                  this.dialogRef.close();
                });
              },
              (error: any) => {
                this.showErrorDialog(error.error.message || 'Error in salary submission.');
              }
            );
          };

          // ✅ Flow based on candidate existence
          if (this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]) {
            generateEmployeeCode();
            createSalary();
          } else {
            // Step 2: Create HR Data

            this.httpService.callPostService(this.config.createByHR, fromData).subscribe(
              (hrRes: any) => {
                generateEmployeeCode();
                createSalary();
              },
              (error: any) => {
                this.showErrorDialog(error.error.message || 'Error in HR creation.');
              }
            );
          }
        },
        (error: any) => {
          this.showErrorDialog(error.error.message || 'Error in adding employee.');
        }
      );
    }


  }
  showErrorDialog(message: string): void {
    this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: 'red',
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
  }

  calculateAgeFromDOB() {
    const dob = new Date(this.employeeForm.value.dateOfBirth)
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    this.employeeForm.controls['age'].setValue(age);
  }
  employeecodeData: any = []
  getEmployeeListCode() {
    this.httpService.callGetService(`${this.config.eployeeCodeList}?companyId=${this.loggedInUserCompanyID}&candidateId=${this.candidateDetails.candidateId}&year=${this.selectedYearForCompetency}`).subscribe((record: any) => {
      let data = record.data;
      console.log(data, "...........");

      this.employeecodeData = data?.filter((elm: any) => elm.candidateId == this.candidateDetails.candidateId || elm.departmentName == this.employeeForm.value.department || elm.locationName == this.employeeForm.value.workLocationState)
    })
  }





  updateAllFrom() {


    if (this.employeeForm.invalid || this.showErrorMsgOfExistAccountNo || this.showErrorMsgOfExistAddharNo || this.showErrorMsgOfExistPAN || this.showErrorMsgOfExistUAN ||this.areAnyFieldsTooLong())  {
      this.addSubmitForm = true;
      this.employeeForm.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return
    }
    // console.log(this.showErrorMsgOfExistPAN);
    // Set manual errors on the respective controls

    let data = this.employeeForm.value;

    let depetMent = data.department.label || data.department

    let ForReportingManager = this.assignReporteesDropdown?.find((record: any) => record.id == data?.reportingManagerName);
    let ForHodName = this.assignReporteesDropdown?.find((record: any) => record.id == data?.hodName);

 let ForDottedName = this.assignReporteesDropdown?.find((record: any) => record.id == data?.dottedReportingManagerName);
 
console.log(ForDottedName);



    const updaeteFromdata = {
      salutation: data.salutation,
      firstName: data.firstName,
      lastName: data.lastName,
      gender: data.genders,  // Matching "data.gender" with "genders"
      country: data.country,
      address: data.presentAddress,
      permanentAddress: data.permanentAddress,
      maritalStatus: data.maritalStatus ? data.maritalStatus : null,
      dateOfBirth: data.dateOfBirth ? formatDateToLocalIso(new Date(data.dateOfBirth)) : '',
      age: data.age,
      personalEmail: data.personalEmail,
      aadharNo: data.aadhaarCardNo,  // Matching "data.aadharNo" with "aadhaarCardNo"
      panNo: data.panNo,
      uan: data.unaNo,  // Matching "data.uan" with "unaNo"
      contactNo: data.mobileNo,
      totalExperience: data.previousExperience,  // Matching "data.totalExperience" with "previousExperience"
      emergencyContactNo: data.emergencyContact,
      bloodGroup: data.bloodGroup,
      fathersName: data.fathersName,
      mothersName: data.mothersName,
      spouseName: data.spouseName,
      noOfChildren: data.noOfChildren,
      isRelativeWorking: data.relativeWorking == 'No' ? false : true,

      // Education Related Information
      highestEducationQualification: data.highestEducation,
      highestEducationInstitute: data.highestEducationInstitute,
      highestEducationYearOfPassing: data.highestEducationYear,
      highestEducationMarks: data.highestEducationMarks,
      highestEducationQualification2: data.secondEducation,
      highestEducationInstitute2: data.secondEducationInstitute,
      highestEducationYearOfPassing2: data.secondEducationYear,
      highestEducationMarks2: data.secondEducationMarks,
      highestEducationQualification3: data.thirdEducation,
      highestEducationInstitute3: data.thirdEducationInstitute,
      highestEducationYearOfPassing3: data.thirdEducationYear,
      highestEducationMarks3: data.thirdEducationMarks,
      highestProfessionalQualification: data.highestProfessional,
      highestProfessionalInstitute: data.highestProfessionalInstitute,
      highestProfessionalYearOfPassing: data.highestProfessionalYear,
      highestProfessionalMarks: data.highestProfessionalMarks,

      // Prior Employment Related Information

      // formatDateToLocalIso reusable date method
      lastOrganisationName: data.lastOrganisation,
      lastOrganisationDoj: data.lastOrganisationJoiningDate ? formatDateToLocalIso(new Date(data.lastOrganisationJoiningDate)) : '',
      // lastOrganisationLwd: data.lastOrganisationLastWorkingDate,
      lastOrganisationLwd: data.lastOrganisationLastWorkingDate ? formatDateToLocalIso(new Date(data.lastOrganisationLastWorkingDate)) : '',
      lastOrganisationDepartment: data?.lastOrganisationDepartment,
      lastOrganisationDesignation: data.lastOrganisationDesignation,
      lastToLastOrganisationName: data.lastToLastOrganisation,
      lastToLastOrganisationDoj: data.lastToLastOrganisationJoiningDate ? formatDateToLocalIso(new Date(data.lastToLastOrganisationJoiningDate)) : '',
      lastToLastOrganisationLwd: data.lastToLastOrganisationLastWorkingDate ? formatDateToLocalIso(new Date(data.lastToLastOrganisationLastWorkingDate)) : '',
      lastToLastOrganisationDepartment: data.lastToLastOrganisationDepartment,
      lastToLastOrganisationDesignation: data.lastToLastOrganisationDesignation,
      otherOrganisationName: data.anyOtherOrganisation,
      otherOrganisationDoj: data.anyOtherOrganisationJoiningDate ? formatDateToLocalIso(new Date(data.anyOtherOrganisationJoiningDate)) : '',
      otherOrganisationLwd: data.anyOtherOrganisationLastWorkingDate ? formatDateToLocalIso(new Date(data.anyOtherOrganisationLastWorkingDate)) : '',
      otherOrganisationDepartment: data.anyOtherOrganisationDepartment,
      otherOrganisationDesignation: data.anyOtherOrganisationDesignation,

      //HR
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYearForCompetency,
      // "companyId": this.loggedInUserCompanyID,
      // "candidateId": this.candidateDetails.candidateId,
      "employmentCategory": data?.employmentCategory,
      "employmentType": data.employmentType,
      "retirementAge": data.retirementAge,
      "empStatus": data.empStatus,
      "dateOfJoining": formatDate(data.dateOfJoining, 'yyyy-MM-dd', 'en-US'),
      "groupName": data.groupName.label || data.groupName,
      "companyName": data.companyName.label || data.companyName,
      "reportingManagerName": ForReportingManager ? ForReportingManager.name : data?.reportingManagerName,
      "reportingManagerCode": data.reportingManagerCode,
      "dottedReportingManagerName": ForDottedName?ForDottedName.name: data?.dottedReportingManagerName,
      "dottedReportingManagerCode": data.dottedReportingManagerCode,
      "hodName": ForHodName ? ForHodName.name : data?.hodName,
      "hodCode": data.hodCode,
      "band": data.band.label?.trim() || data.band?.trim(),
      "grade": data.grade.label?.trim() || data.grade?.trim(),
      "designation": data.designation.label || data.designation,
      "department": depetMent,
      "subDepartment": data.subDepartment,
      "workLocationState": data.workLocationState.label || data.workLocationState,
      "workLocationCity": data.workLocationCity,
      "designationAtDoj": data.designationAtDoj.label || data.designationAtDoj,
      "noOfPromotions": data.noOfPromotions,
      "currentPerformanceScore": data.currentPerformanceScore,
      "currentPerformanceRating": data.currentPerformanceRating,
      "lastYearPerformanceScore": data.lastYearPerformanceScore,
      "lastYearPerformanceRating": data.lastYearPerformanceRating,
      "yearBeforeLastYearPerformanceScore": data.yearBeforeLastYearPerformanceScore,
      "yearBeforeLastYearPerformanceRating": data.yearBeforeLastYearPerformanceRating,

      "mailBody": "Please review the submitted form for further processing.",
      "mailSubject": "Candidate Employment Form Submission",

      // salary
      // "hrId": this.loggedInUserId,

      "currency": data.currency,
      "salaryStatus": data.salaryStatus,
      "bankName": data.bankName.label || data.bankName,
      "bankBranchAddress": data.bankBranchAddress,
      "bankAccount": data.bankAccount,
      "ifscCode": data.ifscCode,
    "effectiveDate": data?.effectiveDate ? formatDate(data?.effectiveDate, 'yyyy-MM-dd', 'en-US') : null,

      "basicSalaryPm": data.basicSalaryPm,
      "daPm": data.daPm,
      "hraPm": data.hraPm,
      "otherAllowancePm": data.otherAllowancePm,
      "ltaPm": data.ltaPm,
      "medicalAllowancePm": data.medicalAllowancePm,
      "washingAllowancePm": data.washingAllowancePm,
      "specialAllowancePm": data.specialAllowancePm,
      "fuelAllowancePm": data.fuelAllowancePm,
      "entertainmentAllowancePm": data.entertainmentAllowancePm,
      "educationAllowancePm": data.educationAllowancePm,
      "booksAllowancePm": data.booksAllowancePm,
      "statutoryBonusPm": data.statutoryBonusPm,
      "anyOtherAllowancePm": data.anyOtherAllowancePm,
      "grossSalaryPm": data.grossSalaryPm,
      "employeePfPm": data.employeePfPm,
      "employerPfPm": data.employerPfPm,
      "ptPm": data.ptPm,
      "customValues": this.customFieldData,
      "lwfPm": data.lwfPm,
      "esicPm": data.esicPm,
      "otherRetiralPm": data.otherRetiralPm,
      "totalRetiralPm": data.totalRetiralPm,
      "totalCTCIncludingRetiralPM": data.totalCTCIncludingRetiralPM,
      "totalCTCIncludingRetiralPA": data.totalCTCIncludingRetiralPA,
      "processOfVp": data.processOfVp,
      "annualVariablePayBudget": data.annualVariablePayBudget,
      "annualTotalCtc": data.annualTotalCtc,
      "incrementOn": data.incrementOn
    };

    console.log(this.employeeForm.controls);

    if (this.employeeForm.invalid) {
      this.addSubmitForm = true;
      this.employeeForm.markAllAsTouched();
    }


    if (this.employeeForm.valid) {
      this.httpService.callPutService(`${this.config.updateHRInfo}/${this.candidateDetails.candidateId}/companyId/${this.loggedInUserCompanyID}`, updaeteFromdata).subscribe((data: any) => {
        console.log(data);

        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          //------------------------------employee Code -------------------------------------------------------
          let filterdepat = this.arrAllDepartmentCode?.filter((elm: any) => elm?.departmentName == this.employeeForm?.value.department);
          let filterlocation = this.arrAllLocationList?.filter((elm: any) => elm?.locationName == this.employeeForm?.value.workLocationState);

          console.log(this.isManual);

          console.log(this.employeecodeData);

          if (!this.isManual && this.employeecodeData) {

            let employeecodeFromData = {
              "id": this.employeecodeData[0]?.id || null,
              "companyId": this.loggedInUserCompanyID,
              "changeByUserId": this.loggedInUserId,
              "companyCodeId": this.getEmployeeCodeDataList?.companyCodeId, // FROM 1ST TABLE COMPANY_CODE 
              "manual": false,
              "employeeCodeSelection": this.selectedDeptLocation, // OPTIONS : DEPARTMENT, LOCATION, BOTH
              "prefix": this.setPrefix,
              "locationName": filterlocation ? filterlocation[0]?.locationName : null,
              "departmentName": filterdepat ? filterdepat[0]?.departmentName : null,
              "startNumber": this.setLimit,
              "locationCode": filterlocation ? filterlocation[0]?.locationPrefix : null,
              "departmentCode":filterdepat? filterdepat[0]?.departmentPrefix:null,
              "candidateId": this.candidateDetails?.candidateId,
              //  "finalCode": "EMP0001NYCHR",
              "year": this.selectedYearForCompetency,
              "fiscalYear": this.loggedInCompanyFiscalyear

            }
            this.httpService.callPostService(this.config.employeeFinalCode, employeecodeFromData).subscribe((data: any) => {

            })
          }

          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close("updated");
          });


        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.message || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            // this.dialogRef.close();
            console.log('Error dialog closed');
          });
        }
      )

    }
  }

  onDepartmentChange(selectedValue: string) {
    // Check if the selected value exists in the department list
    console.log(selectedValue);
    const exists = this.CombineDeptArray.some((item: any) => item.department === selectedValue || item.department === selectedValue);

    if (!exists && selectedValue !== undefined) {
      this.addDeptAndLoc(selectedValue);  // Open add department function
    }
  }

}
